// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const BodyFeedbackAttachmentUploadApiFeedbackAttachmentsPost = zod.object({
  "file": zod.instanceof(Blob)
});

export type BodyFeedbackAttachmentUploadApiFeedbackAttachmentsPost = zod.input<typeof BodyFeedbackAttachmentUploadApiFeedbackAttachmentsPost>;
export type BodyFeedbackAttachmentUploadApiFeedbackAttachmentsPostOutput = zod.output<typeof BodyFeedbackAttachmentUploadApiFeedbackAttachmentsPost>;
